var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2592_53",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2592_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 30C7.75 30 6.6875 29.5625 5.8125 28.6875C4.9375 27.8125 4.5 26.75 4.5 25.5H1.5V8.99999C1.5 8.17499 1.79375 7.46874 2.38125 6.88124C2.96875 6.29374 3.675 5.99999 4.5 5.99999H25.5V12H30L34.5 18V25.5H31.5C31.5 26.75 31.0625 27.8125 30.1875 28.6875C29.3125 29.5625 28.25 30 27 30C25.75 30 24.6875 29.5625 23.8125 28.6875C22.9375 27.8125 22.5 26.75 22.5 25.5H13.5C13.5 26.75 13.0625 27.8125 12.1875 28.6875C11.3125 29.5625 10.25 30 9 30ZM9 27C9.425 27 9.78125 26.8562 10.0688 26.5687C10.3562 26.2812 10.5 25.925 10.5 25.5C10.5 25.075 10.3562 24.7187 10.0688 24.4312C9.78125 24.1437 9.425 24 9 24C8.575 24 8.21875 24.1437 7.93125 24.4312C7.64375 24.7187 7.5 25.075 7.5 25.5C7.5 25.925 7.64375 26.2812 7.93125 26.5687C8.21875 26.8562 8.575 27 9 27ZM4.5 22.5H5.7C6.125 22.05 6.6125 21.6875 7.1625 21.4125C7.7125 21.1375 8.325 21 9 21C9.675 21 10.2875 21.1375 10.8375 21.4125C11.3875 21.6875 11.875 22.05 12.3 22.5H22.5V8.99999H4.5V22.5ZM27 27C27.425 27 27.7812 26.8562 28.0687 26.5687C28.3562 26.2812 28.5 25.925 28.5 25.5C28.5 25.075 28.3562 24.7187 28.0687 24.4312C27.7812 24.1437 27.425 24 27 24C26.575 24 26.2188 24.1437 25.9313 24.4312C25.6438 24.7187 25.5 25.075 25.5 25.5C25.5 25.925 25.6438 26.2812 25.9313 26.5687C26.2188 26.8562 26.575 27 27 27ZM25.5 19.5H31.875L28.5 15H25.5V19.5Z",
    fill: "#1D8145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.df95fe19d47a271d576935276b401955.svg";
export { ForwardRef as ReactComponent };